import { render, staticRenderFns } from "./SummaryAddress.vue?vue&type=template&id=5fc17454&"
import script from "./SummaryAddress.vue?vue&type=script&lang=js&"
export * from "./SummaryAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports